<div class='input-field' [ngClass]="{'active': isFocus, 'error':error}">
  <span *ngIf='tooltipText && isFocus' class='tooltip'>{{tooltipText}}</span>
  <input #inputCtrl 
    [id]="id" 
    [type]="type !== 'password' ? type : isPasswordVisible ? 'text' : type" 
    [autocomplete]="autocomplete"
    [(ngModel)]="value"
    (focus)='setInputFocus(true)'
    (blur)='setInputFocus(false)'
    [minlength]="minLength"
    [maxlength]="maxLength"
    [ngClass]="{'password-input' : type === 'password'}"
  />
  <label [attr.for]="id"  [ngClass]="{'active': valueLength() || isFocus}">
    {{labelText}}
  </label>
  <mat-icon 
    *ngIf="type === 'password'"
    class='password-visibility'
    (click)='togglePasswordVisibility()'
    [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'" 
    [title]="isPasswordVisible ? 'Hide password' : 'Show password'"
  >
    {{isPasswordVisible ? 'visibility' : 'visibility_off'}}
  </mat-icon>
</div>